<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.farmerCode')">
                <j-input :placeholder="$t('label.pleaseEnterTheFarmerCode')" v-model="queryParam.code"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.farmerName')">
                <j-input :placeholder="$t('label.pleaseEnterTheFarmerName')" v-model="queryParam.name"></j-input>
              </a-form-item>
            </a-col>
<!--            <template v-if="toggleSearchStatus">-->
<!--              <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--                <a-form-item :label="$t('label.validOrNot')">-->
<!--                  <j-dict-select-tag placeholder="请选择是否有效" v-model="queryParam.validFlag" dictCode="sfyx"/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
            </a-col>
          </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button v-has="'efsMdFarmer:farm'" @click="handleAddFarm()" type="primary" icon="plus">{{$t('button.newFarm')}}</a-button>
      <a-button v-show=false type="primary" icon="download" @click="handleExportXls('efs_md_farmer')">{{$t('button.export')}}</a-button>
      <a-upload v-show=false name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <!--<a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>-->
              <a-menu-item v-has="'efsMdFarmer:sync'" v-if="record.syncStatus!='30'">
                <a-popconfirm :title="$t('tip.confrimSynchronization')" @confirm="() => handleSync(record)">
                  <a>{{ $t('button.sync') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-farmer-modal ref="modalForm" @ok="modalFormOk"></efs-md-farmer-modal>
    <efs-depart-modal ref="efsDepartModal" @ok="modalFormOk"></efs-depart-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdFarmerModal from './modules/EfsMdFarmerModal'
  import EfsDepartModal from './modules/EfsDepartModal'
  import JInput from '@/components/jeecg/JInput'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'EfsMdFarmerList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMdFarmerModal,
      EfsDepartModal,
      JInput
    },
    data () {
      return {
        mainTable: 'efs_md_farmer',
        description: 'efs_md_farmer管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            //title:'编码',
            slotName: 'tableHeader.number',
            align:"center",
            dataIndex: 'code',
            scopedSlots: { title: 'tableHeader.number'}
          },
          {
            //title:'养户名称',
            slotName: 'tableHeader.growerName',
            align:"center",
            dataIndex: 'name',
            scopedSlots: { customRender: 'name', title: 'tableHeader.growerName' }
          },
          {
            //title:'养户类型',
            slotName: 'tableHeader.farmerType',
            align:"center",
            dataIndex: 'farmerType_dictText',
            scopedSlots: { title: 'tableHeader.farmerType'}
          },
          {
            //title:'公司',
            slotName: 'tableHeader.company',
            align:"center",
            dataIndex: 'companyCode_dictText',
            scopedSlots: { title: 'tableHeader.company'}
          },

          {
            //title:'技术员',
            slotName: 'tableHeader.technician',
            align:"center",
            dataIndex: 'managerCode_dictText',
            scopedSlots: { title: 'tableHeader.technician'}
          },
            {
                //title:'创建时间',
                slotName: 'tableHeader.creationTime',
                align:"center",
                dataIndex: 'createTime',
                customRender:function (text) {
                    return !text?"":(text.length>10?text.substr(0,10):text)
                },
                scopedSlots: { title: 'tableHeader.creationTime'}
            },

          {
            //title:'状态',
            slotName: 'tableHeader.status',
            align:"center",
            dataIndex: 'validFlag_dictText',
            scopedSlots: { title: 'tableHeader.status'}
          },
            {
                //title:'同步状态',
                slotName: 'tableHeader.syncStatus',
                align:"center",
                dataIndex: 'syncStatus_dictText',
                scopedSlots: { title: 'tableHeader.syncStatus'}
            },
            {
                //title:'同步消息',
                slotName: 'tableHeader.syncMessage',
                align:"center",
                dataIndex: 'syncMsg',
                scopedSlots: { title: 'tableHeader.syncMessage'}
            },
          {
            //title: '操作',
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/farmerArchive/efsMdFarmer/list",
          delete: "/farmerArchive/efsMdFarmer/delete",
          deleteBatch: "/farmerArchive/efsMdFarmer/deleteBatch",
          exportXlsUrl: "/farmerArchive/efsMdFarmer/exportXls",
          importExcelUrl: "farmerArchive/efsMdFarmer/importExcel",
          getSyncFarmerInterface: "/farmerArchive/efsMdFarmer/syncFarmerCode",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      handleSync(record){
          if(!this.url.getSyncFarmerInterface){
              this.$message.error(this.$t('tip.pleaseSet') + "url.getSyncFarmerInterface!")
              return
          }
          postFormAction(this.url.getSyncFarmerInterface, {id: record.id}).then((res) => {
              if (res.success) {
                  this.$message.success(res.message);
                  this.loadData();
                  this.onClearSelected();
              } else {
                  this.$message.warning(res.message);
              }
          }).finally(() => {
              this.loading = false;
          });
      },
      handleAddFarm() {
          if(this.selectedRowKeys.length==1){
              this.$refs.efsDepartModal.add(this.selectionRows[0])
              this.$refs.efsDepartModal.title =  this.$t('button.add')
          }else{
              this.$message.warning(this.$t('label.pleaseSelectAData'));
          }

      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>